import React, { createContext, useContext, useCallback } from "react";
import { apiConfig } from "../services/authConfig";
import { LoackerService } from "../services/service";
type QueryFn = (data: any) => Promise<any>;

interface FlowiseContextType {
  query: QueryFn;
}

const FlowiseContext = createContext<FlowiseContextType | undefined>(undefined);

export const FlowiseProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const query = useCallback(async (data: any) => {
    // attach sessionId based on current user email so each user has separate chat session
    try {
      const user = LoackerService.getUser();
      let bodyData = data || {};
      if (user && user.email) {
        const raw = String(user.email).toLowerCase();
        // replace non-alphanumeric characters with underscore to form a safe session id
        const sessionId = raw.replace(/[^a-z0-9]/g, "_");
        bodyData = {
          ...bodyData,
          overrideConfig: {
            ...(bodyData.overrideConfig || {}),
            sessionId,
          },
        };
      }

      const token = await LoackerService.acquireCentralGatewayToken();
      if (!token) {
        throw new Error("No access token available for Flowise request");
      }

      const resp = await fetch(`${apiConfig.centralGatewayAPIUri}flowise`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(`Flowise proxy error: ${resp.status} ${text}`);
      }

      return resp.json();
    } catch (err) {
      // rethrow to let callers handle errors
      throw err;
    }
  }, []);

  return (
    <FlowiseContext.Provider value={{ query }}>
      {children}
    </FlowiseContext.Provider>
  );
};

export const useFlowise = () => {
  const ctx = useContext(FlowiseContext);
  if (!ctx) throw new Error("useFlowise must be used within FlowiseProvider");
  return ctx;
};
